import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class QueryParamsService {

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) { }

  // ✅ Obtener todos los params (observable)
  getParams(): Observable<any> {
    return this.route.queryParams;
  }

  // ✅ Obtener un param específico
  getParam(key: string): string | null {
    return this.route.snapshot.queryParamMap.get(key);
  }

  getNumberParam(key: string, defaultValue: number): number {
    const value = Number(this.route.snapshot.queryParamMap.get(key));
    return isNaN(value) ? defaultValue : value;
  }

  getStringParam(key: string, defaultValue: string): string {
    const value = this.route.snapshot.queryParamMap.get(key);
    return value && value.trim() !== '' ? value : defaultValue;
  }

  // ✅ Agregar o actualizar params dinámicamente
  setParams(params: any): void {
    this.router.navigate([], {
      queryParams: params,
      queryParamsHandling: 'merge' // 🔥 clave para hacerlo dinámico
    });
  }

  // ✅ Eliminar un param
  removeParam(key: string): void {
    const currentParams = { ...this.route.snapshot.queryParams };
    delete currentParams[key];

    this.router.navigate([], {
      queryParams: currentParams
    });
  }

  // ✅ Limpiar todos los params
  clearParams(): void {
    this.router.navigate([], {
      queryParams: {}
    });
  }
}
